import { Some, None } from '../../../option/shared/option.js';

const ContentDataType = {
    Json: 'json',
    Text: 'text',
    Blob: 'blob',
    ArrayBuffer: 'arrayBuffer',
    Bytes: 'bytes',
};
const RequestContentDataType = { ...ContentDataType, FormData: 'formData' };
const DEFAULT_CONTENT_TYPE = {
    [ContentDataType.Json]: 'application/json',
    [ContentDataType.Text]: 'text/plain',
    [ContentDataType.ArrayBuffer]: 'application/octet-stream',
    [ContentDataType.Bytes]: 'application/octet-stream',
    [RequestContentDataType.FormData]: 'multipart/form-data',
};
/**
 * Преобразует стандартный тип данных в заголовок Content-Type.
 * _Blob должен уже содержать MIME-type._
 *
 * @export
 * @param {(Exclude<ContentDataType | RequestContentDataType, 'blob'>)} contentType
 * @param {ContentTypeToHeaderOpts} [opts={}]
 * @return {ContentTypeHeader}
 */
function contentTypeToHeader(contentType, opts = {}) {
    let header = DEFAULT_CONTENT_TYPE[contentType];
    if (opts.charset) {
        header += `; charset=${opts.charset}`;
    }
    if (opts.boundary) {
        header += `; boundary=${opts.boundary}`;
    }
    return header;
}
const JSON_REGEXP = /[/+]json($|[^-\w])/i;
const TEXT_REGEXP = /^text\//i;
/**
 * Парсит заголовок Content-Type и возвращает тип данных тела ответа
 *
 * @export
 * @param {ContentTypeHeader} header
 * @return {Option<ResponseContentDataType>}
 */
function parseResponseContentTypeHeader(header) {
    if (JSON_REGEXP.test(header)) {
        return Some(ContentDataType.Json);
    }
    if (header.startsWith(DEFAULT_CONTENT_TYPE[ContentDataType.ArrayBuffer]) ||
        header.startsWith(DEFAULT_CONTENT_TYPE[ContentDataType.Bytes])) {
        return Some(ContentDataType.ArrayBuffer);
    }
    if (TEXT_REGEXP.test(header)) {
        return Some(ContentDataType.Text);
    }
    return None();
}

export { ContentDataType, RequestContentDataType, contentTypeToHeader, parseResponseContentTypeHeader };
//# sourceMappingURL=contentType.js.map
